import { ActionBrick, registerBrick, ErrorFlow, Query, Transaction, Relation, Direction } from 'olympe';

export default class GenerateMockRelations extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!CloudObject} modelA
     * @param {!CloudObject} modelB
     * @param {!Relation} relationAToB
     * @param {number} relationChance
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     */
    async update($, [modelA, modelB, relationAToB, cardinality, relationChance], [forwardEvent, _setErrorFlow]) {
        // Guards
        if (!modelA || !modelB || !relationAToB || !cardinality || relationChance < 0.0 || relationChance > 1.0) {
            throw ErrorFlow.create(`Some inputs are invalid: (${modelA}, ${modelB}, ${relationAToB}, ${cardinality}, 0.0 <= ${relationChance} <= 1.0)`, 0);
        }

        // Get all instances of both models
        const instancesA = await Query.instancesOf(modelA).execute();
        const instancesB = await Query.instancesOf(modelB).execute();

        // Build the transaction
        const t = Transaction.from($);
        const build = GenerateMockRelations.BUILDERS[cardinality];
        build(t, instancesA, instancesB, relationAToB, relationChance);

        // Execute the transation
        const success = await Transaction.process($, t);
        if(success) {
            forwardEvent();
        }
        else {
            throw ErrorFlow.create('The transaction failed', 0);
        }
    }
}

registerBrick('018ee6debba65b3c702e', GenerateMockRelations);

// One to Many logic
GenerateMockRelations.oneToMany = (t, instancesA, instancesB, relationAToB, relationChance) => {
    const used = new Set();
    instancesA.forEach(a => {
        instancesB.forEach(b => {
            // Create a relation if the coinflip is ok
            //  and if the b instance has not yet been used
            if(!used.has(b.getTag()) && Math.random() <= relationChance) {
                t.createRelation(relationAToB, a, b);
                used.add(b.getTag());
            }
        });
    });
};

// Builders
GenerateMockRelations.BUILDERS = {
    // Many to Many
    'Many to Many': (t, instancesA, instancesB, relationAToB, relationChance) => {
        instancesA.forEach(a => {
            instancesB.forEach(b => {
                // Create a relation if the coinflip is ok
                if(Math.random() <= relationChance) {
                    t.createRelation(relationAToB, a, b);
                }
            });
        });
    },
    
    // One to Many
    'One to Many': GenerateMockRelations.oneToMany,
    
    // Many to One
    'Many to One': (t, instancesA, instancesB, relationAToB, relationChance) => {
        GenerateMockRelations.oneToMany(t, instancesB, instancesA, new Relation(relationAToB, Direction.ORIGIN), relationChance);
    },
    
    // One to One
    'One to One': (t, instancesA, instancesB, relationAToB, relationChance) => {
        const used = new Set();
        const instancesBArray = instancesB.toArray();
        instancesA.forEach(a => {
            for(let b of instancesBArray) {
                // Create a relation if the coinflip is ok
                //  and if the b instance has not yet been used
                //  and quit directly because the a instance is now used
                if(!used.has(b.getTag()) && Math.random() <= relationChance) {
                    t.createRelation(relationAToB, a, b);
                    used.add(b.getTag());
                    break;
                }
            }
        });
    }
};